import { useEffect, useState } from "react";

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const endDate = new Date(targetDate);

    const timer = setInterval(() => {
      const now = new Date();
      const diff = Math.floor((endDate - now) / 1000);

      if (diff <= 0) {
        clearInterval(timer);
        setIsExpired(true);
        return;
      }

      const days = Math.floor(diff / 86400);
      const hours = Math.floor((diff % 86400) / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = diff % 60;

      setTimeLeft({
        days: padNumber(days),
        hours: padNumber(hours),
        minutes: padNumber(minutes),
        seconds: padNumber(seconds),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const padNumber = (n) => (n < 10 ? "0" + n : n);

  if (isExpired) {
    return (
      <main
        id="normalbtn"
        className="container"
        style={{ marginTop: 20 }}
        data-animation="fadeInLeft"
        data-delay="0.8s"
      >
      </main>
    );
  }

  return (
    <>
    <style>{`
        .countdown-card {
          background-color: #fff;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(96,134,181,.3);
          margin-top: 20px;
          text-align: center;
        }
        .countdown-card .card_body {
          font-size: 0;
          padding: 1.25rem;
        }
        .countdown-card .card_title {
          font-size: 2rem;
          margin: 0 0 .75rem;
        }
        .countdown-card .countdown_section {
          display: inline-block;
          margin-left: 4px;
        }
        .countdown-card .countdown_section:first-child {
          margin-left: 0;
        }
        .countdown-card .countdown_section .value {
          background-color: rgba(0, 106, 255, 0.8);
          border-radius: 10px;
          font-size: 50px;
          color: #ffffffff;
          line-height: 100px;
          text-align: center;
          height: 100px;
          width: 100px;
        }
        .countdown-card .countdown_label {
          font-size: 11px;
          padding-top: 4px;
          text-align: center;
        }
      `}</style>
      <main
        className="container"
        style={{ marginLeft: 0 }}
        data-animation="fadeInLeft"
        data-delay="0.8s"
      >
        <div className="card countdown-card">
          <div className="card_body">
            <h2 className="card_title">
              DEAL WILL EXPIRES IN 
            </h2>

            <div className="countdown_section">
              <div className="value">{timeLeft.days || "00"}</div>
              <div className="countdown_label">DAYS</div>
            </div>
            <div className="countdown_section">
              <div className="value">{timeLeft.hours || "00"}</div>
              <div className="countdown_label">HOURS</div>
            </div>
            <div className="countdown_section">
              <div className="value">{timeLeft.minutes || "00"}</div>
              <div className="countdown_label">MINUTES</div>
            </div>
            <div className="countdown_section">
              <div className="value">{timeLeft.seconds || "00"}</div>
              <div className="countdown_label">SECONDS</div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default CountdownTimer